import classes from './PTextField.module.scss'

export default function PTextField(props: { value: string, className?: string, onChange: (text: string) => void }) {
  return <input
    type="text"
    value={props.value}
    className={classes.input + ' ' + props.className}
    onChange={e => props.onChange(e.target.value)}/>
}
